import { Link } from "react-router-dom";
import { StatusBadge } from "@/components/ui/status-badge";
import type { VendorDetail } from "@/lib/api/acquisitions";

type VendorRecentOrdersProps = {
  orders: VendorDetail["purchaseOrders"];
};

function statusVariant(status: string): "success" | "danger" | "info" | "warning" | "neutral" {
  if (status === "CLOSED" || status === "FULLY_RECEIVED") return "success";
  if (status === "CANCELLED") return "danger";
  if (status === "PARTIALLY_RECEIVED") return "warning";
  if (status === "DRAFT") return "neutral";
  return "info";
}

export function VendorRecentOrders({ orders }: VendorRecentOrdersProps) {
  return (
    <section className="rounded-lg border border-slate-200 bg-white px-4 py-4 sm:px-5">
      <h2 className="text-sm font-semibold text-slate-900">Recent orders</h2>
      {orders.length === 0 ? (
        <p className="mt-3 text-sm text-slate-500">No purchase orders for this vendor yet.</p>
      ) : (
        <ul className="mt-3 divide-y divide-slate-100">
          {orders.map((po) => (
            <li
              key={po.id}
              className="flex items-center justify-between gap-3 py-2.5 first:pt-0 last:pb-0"
            >
              <div className="min-w-0">
                <Link
                  to={`/acquisitions/orders/${po.id}`}
                  className="font-mono text-sm font-medium text-primary hover:underline"
                >
                  {po.orderNumber}
                </Link>
                <p className="text-xs text-slate-500">
                  {new Date(po.createdAt).toLocaleDateString()}
                </p>
              </div>
              <StatusBadge variant={statusVariant(po.status)}>
                {po.status.replace(/_/g, " ")}
              </StatusBadge>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
